export const EQUIFAX_VIC_BUILD_IDENTIFIERS = 'EQUIFAX_VIC_BUILD_IDENTIFIERS';
export const EQUIFAX_VIC_BUILD_IDENTIFIERS_SUCCESS = 'EQUIFAX_VIC_BUILD_IDENTIFIERS_SUCCESS';
export const EQUIFAX_VIC_BUILD_IDENTIFIERS_FAIL = 'EQUIFAX_VIC_BUILD_IDENTIFIERS_FAIL';

export const EQUIFAX_VIC_SELECT_IDENTIFIER = 'EQUIFAX_VIC_SELECT_IDENTIFIER';
export const EQUIFAX_VIC_SELECT_IDENTIFIER_SUCCESS = 'EQUIFAX_VIC_SELECT_IDENTIFIER_SUCCESS';
export const EQUIFAX_VIC_SELECT_IDENTIFIER_FAIL = 'EQUIFAX_VIC_SELECT_IDENTIFIER_FAIL';

export const EQUIFAX_VIC_LIST_DOCUMENTS = 'EQUIFAX_VIC_LIST_DOCUMENTS';
export const EQUIFAX_VIC_LIST_DOCUMENTS_SUCCESS = 'EQUIFAX_VIC_LIST_DOCUMENTS_SUCCESS';
export const EQUIFAX_VIC_LIST_DOCUMENTS_FAIL = 'EQUIFAX_VIC_LIST_DOCUMENTS_FAIL';

export const EQUIFAX_VIC_PLACE_ORDER = 'EQUIFAX_VIC_PLACE_ORDER';
export const EQUIFAX_VIC_PLACE_ORDER_SUCCESS = 'EQUIFAX_VIC_PLACE_ORDER_SUCCESS';
export const EQUIFAX_VIC_PLACE_ORDER_FAIL = 'EQUIFAX_VIC_PLACE_ORDER_FAIL';

export function equifaxVicBuildIdentifiers(matterId, data) {
  return {
    types: [
      EQUIFAX_VIC_BUILD_IDENTIFIERS,
      EQUIFAX_VIC_BUILD_IDENTIFIERS_SUCCESS,
      EQUIFAX_VIC_BUILD_IDENTIFIERS_FAIL,
    ],
    payload: {
      request: {
        method: 'post',
        url: `/products/equifax/vic/build-identifiers/${matterId}`,
        data,
      },
    },
  };
}

export function equifaxVicSelectIdentifier(matterId, data) {
  return {
    types: [
      EQUIFAX_VIC_SELECT_IDENTIFIER,
      EQUIFAX_VIC_SELECT_IDENTIFIER_SUCCESS,
      EQUIFAX_VIC_SELECT_IDENTIFIER_FAIL,
    ],
    payload: {
      request: {
        method: 'post',
        url: `/products/equifax/vic/select-identifier/${matterId}`,
        data,
      },
    },
  };
}

export function equifaxVicListDocuments(matterId, continuationToken) {
  return {
    types: [
      EQUIFAX_VIC_LIST_DOCUMENTS,
      EQUIFAX_VIC_LIST_DOCUMENTS_SUCCESS,
      EQUIFAX_VIC_LIST_DOCUMENTS_FAIL,
    ],
    payload: {
      request: {
        method: 'post',
        url: `/products/equifax/vic/list-documents/${matterId}`,
        data: { continuationToken },
      },
    },
  };
}

export function equifaxVicPlaceOrder(payload) {
  return {
    types: [
      EQUIFAX_VIC_PLACE_ORDER,
      EQUIFAX_VIC_PLACE_ORDER_SUCCESS,
      EQUIFAX_VIC_PLACE_ORDER_FAIL,
    ],
    payload: {
      request: {
        method: 'post',
        url: '/orders/equifax-vic',
        data: payload,
      },
    },
  };
}
